/*
	Компілюється у файл
*/
process.env.NODE_ENV === 'production' ? console.log('Production mode!') : require('__page/index.html');

/*
	Підключаєм конструктор модулів
*/
const mc = require('__libs/ModuleConstructor.js');

const ScrollDetective = require('scroll-detective');

let sd = new ScrollDetective({
	onVisible: el => {
		el.classList.add('complete');
	}
});


sd.addBlocks(".top_laptop");
sd.addBlocks(".fourBlocks ul li");
sd.addBlocks("#setcion-3 .row .cols .block");
sd.addBlocks("#setcion-4");
sd.checkStates();
sd.addScrollEvent();

/**
	Запускаєм конструктор модулів. Аргументом приймає масив назв vue-компонентів,
	які треба включити в процес збірки проекту.
	@type {Array<String>}
*/
mc(['Slider']);

/*
	Запускаєм скріпти html компонентів
*/
STACK.forEach(f => {
	f($);
})



// WEBPACK FOOTER //
// ./entries/detail.js